import { Stack } from "@mui/material"
import { useField } from "formik"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { FormikCurrencyField } from "../../../../../../modules/merchant/admin/products/components/FormikCurrencyField"
import { StandardButton } from "../../../../buttons/StandardButton"
import { FormikTextField } from "../../../../forms/Formik"
import { ProductWishFormValues } from "./ProductWishForm"
import { sanitizeAndLimitInput } from "../../form/helpers"
import { INVALID_INPUT_KEY } from "../../../../../../modules/nonAdminUser/reports/settings/wallets/refill/components/WalletsRefillManual"

type ProductWishFormContentProps = Readonly<{
    isShowPriceField: boolean
}>

export function ProductWishFormContent({ isShowPriceField }: ProductWishFormContentProps) {
    const [, metaPrice] = useField<ProductWishFormValues["price"]>("price")

    return (
        <Stack gap="1.5rem" alignItems="flex-start">
            <LocalizedStrict
                id="create-order-wish-dialog-product-name-field"
                attrs={{ label: true, placeholder: true }}
            >
                <FormikTextField<ProductWishFormValues>
                    name="name"
                    label="Product name *"
                    placeholder="Enter product name:"
                    fullWidth
                />
            </LocalizedStrict>
            <LocalizedStrict
                id="create-order-wish-dialog-product-items-field"
                attrs={{ label: true, placeholder: true }}
            >
                <FormikTextField<ProductWishFormValues>
                    label="Product items *"
                    placeholder="Enter items:"
                    name="quantity"
                    type="number"
                    inputProps={{
                        inputMode: "numeric",
                        onInput: (e: React.FormEvent<HTMLInputElement>) => {
                            const sanitized = sanitizeAndLimitInput(e.currentTarget.value, 6)
                            if (e.currentTarget.value !== sanitized) {
                                e.currentTarget.value = sanitized
                            }
                        },
                        onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                            if (INVALID_INPUT_KEY.includes(e.key)) {
                                e.preventDefault()
                            }
                        },
                    }}
                />
            </LocalizedStrict>
            {isShowPriceField && (
                <Stack>
                    <LocalizedStrict
                        id="create-order-wish-dialog-product-price-field"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikCurrencyField
                            name="price"
                            label="Product price *"
                            placeholder="Enter price (DKK):"
                            errorMessage={metaPrice.error}
                            fullWidth={false}
                            inputTextAlign="left"
                            containerDirection="column"
                            gap={0.25}
                        />
                    </LocalizedStrict>
                </Stack>
            )}
            <Stack flexDirection="row" justifyContent="center" width="100%">
                <LocalizedStrict id="create-order-wish-dialog-submit-button">
                    <StandardButton fullWidth={false} type="submit">
                        Confirm
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
        </Stack>
    )
}
